import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import allActions from "../../store/redux-actions";
import Services from "../../services";
const DoiMatKhauModal = ({ nhanVienUp }) => {
    const dispatch = useDispatch()
    const [nhanVien, setnhanVien] = useState({
        "_id": "",
        "hoTen": "",
        "anhDaiDien": "",
        "gioiTinh": "",
        "diaChi": "",
        "soCMND": "",
        "soDienThoai": "",
        "matKhau": "",
        "matKhauCu": "",
        "matKhauMoi": "",
        "phongBan": { "_id": "" }
    });
    const [error, setError] = useState("");
    function onChange(e) {
        if (e.target.name == 'matKhau') {
            setnhanVien((nhanVien) => ({ ...nhanVien, matKhau: e.target.value }));
        } else if (e.target.name == 'matKhauMoi') {
            setnhanVien((nhanVien) => ({ ...nhanVien, matKhauMoi: e.target.value }));
        } else if (e.target.name == 'matKhauCu') {
            setnhanVien((nhanVien) => ({ ...nhanVien, matKhauCu: e.target.value }));
        }
        setError("")
    }
    function kiemtraNV() {


        if (nhanVien.matKhauCu == "" || nhanVien.matKhauCu == undefined || nhanVien.matKhauCu.length < 6) {
            setError("Mật khẩu cũ không hợp lệ")
            return false;
        }
        if (nhanVien.matKhau == "" || nhanVien.matKhau == undefined || nhanVien.matKhau.length < 6) {
            setError("Mật khẩu mới không hợp lệ")
            return false;
        }
        if (nhanVien.matKhauMoi != nhanVien.matKhau) {
            setError("Mật khẩu nhập lại không đúng")
            return false;
        }
        return true;


    }
    
    function capNhatNV() {
        if (kiemtraNV()) {
            Services.getDangNhapService().kiemTraDoiMatKhau(nhanVien.soDienThoai, nhanVien.matKhauCu).then(
                (response) => {

                    if (response.data != null) {
                        Services.getTaiKhoanService().doiMatKhau(nhanVien).then(
                            (response) => {
                                if (response.data != null) {
                                    if (response.data.noiDung == undefined) {

                                        thoat();
                                        window.location.reload();
                                    }
                                    else setError(response.data.noiDung);
                                }
                            },
                            (error) => {

                            }
                        )

                    }
                },
                (error) => {
                    setError("Mật khẩu cũ không đúng")

                }
            );

        };
    }
    function thoat() {
        dispatch(allActions.displayModalActions.setDisplay(null))
    }

    useEffect(() => {

        setnhanVien(nhanVienUp);
    }, []);
    return (
        <div className="modal" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true" >
            <div className="modal-dialog modal-md" style={{maxWidth:"600px"}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{"ĐỔI MẬT KHẨU"}</h5>
                        <button type="button" className="close" data-dismiss="modal" onClick={(e) => { thoat() }}>×</button>

                    </div>
                    <div className="modal-body">
                        <div><i style={{ color: "red" }}>{error}</i></div>
                        <form className="row" action="/">
                            <div className="row col-12 col-lg-12" >

                                <table >
                                    <tbody>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Nhập mật khẩu cũ:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <input type="password" className="form-control form-control-lg" name="matKhauCu" onInput={(e) => { onChange(e) }} placeholder="Nhập mật khẩu cũ" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Nhập mật khẩu mới:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <input type="password" className="form-control form-control-lg" name="matKhau" onInput={(e) => { onChange(e) }} placeholder="Nhập mật khẩu mới" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Nhập lại mật khẩu mới:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <input type="password" className="form-control form-control-lg" name="matKhauMoi" onInput={(e) => { onChange(e) }} placeholder="Nhập lại mật khẩu mới" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Lưu ý:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch pt-2">
                                                    <p> <i>Nếu đổi mật khẩu thì tất cả tài khoản đã đăng nhập sẽ đăng xuất</i></p>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>



                        </form>


                    </div>
                    <div className="modal-footer">

                        <button onClick={(e) => { capNhatNV() }} className="btn btn-primary me-1">Cập nhật</button>
                        <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e) => { thoat() }}>Thoát</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoiMatKhauModal;